import { createContext, useContext } from 'react';

const UI_VERSION_KEY = 'octopus_ui_version';
const UI_VERSIONS = {
  V2: 'v2'
};

const UIContext = createContext({
  uiVersion: UI_VERSIONS.V2,
  setUIVersion: () => {},
  isV2: true
});

export function UIThemeProvider({ children }) {
  return (
    <UIContext.Provider
      value={{
        uiVersion: UI_VERSIONS.V2,
        setUIVersion: () => {},
        isV2: true
      }}
    >
      {children}
    </UIContext.Provider>
  );
}

export function useUITheme() {
  return useContext(UIContext);
}

export { UI_VERSION_KEY, UI_VERSIONS };
